import { render, staticRenderFns } from "./DashboardSalePromocional.vue?vue&type=template&id=b5100978&scoped=true&"
import script from "./DashboardSalePromocional.vue?vue&type=script&lang=js&"
export * from "./DashboardSalePromocional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5100978",
  null
  
)

export default component.exports